// @ts-nocheck
/* eslint-disable */

import { AllTypesProps, ReturnTypes, Ops } from './const';


export const HOST="Specify host"


export const HEADERS = {}
export const apiSubscription = (options: chainOptions) => (query: string) => {
  try {
    const queryString = options[0] + '?query=' + encodeURIComponent(query);
    const wsString = queryString.replace('http', 'ws');
    const host = (options.length > 1 && options[1]?.websocket?.[0]) || wsString;
    const webSocketOptions = options[1]?.websocket || [host];
    const ws = new WebSocket(...webSocketOptions);
    return {
      ws,
      on: (e: (args: any) => void) => {
        ws.onmessage = (event: any) => {
          if (event.data) {
            const parsed = JSON.parse(event.data);
            const data = parsed.data;
            return e(data);
          }
        };
      },
      off: (e: (args: any) => void) => {
        ws.onclose = e;
      },
      error: (e: (args: any) => void) => {
        ws.onerror = e;
      },
      open: (e: () => void) => {
        ws.onopen = e;
      },
    };
  } catch {
    throw new Error('No websockets implemented');
  }
};
export const apiSubscriptionSSE = (options: chainOptions) => (query: string, variables?: Record<string, unknown>) => {
  const url = options[0];
  const fetchOptions = options[1] || {};

  let abortController: AbortController | null = null;
  let reader: ReadableStreamDefaultReader<Uint8Array> | null = null;
  let onCallback: ((args: unknown) => void) | null = null;
  let errorCallback: ((args: unknown) => void) | null = null;
  let openCallback: (() => void) | null = null;
  let offCallback: ((args: unknown) => void) | null = null;

  const startStream = async () => {
    try {
      abortController = new AbortController();

      const response = await fetch(url, {
        method: 'POST',
        headers: {
          Accept: 'text/event-stream',
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          ...fetchOptions.headers,
        },
        body: JSON.stringify({ query, variables }),
        signal: abortController.signal,
        ...fetchOptions,
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      if (openCallback) {
        openCallback();
      }

      reader = response.body?.getReader() || null;
      if (!reader) {
        throw new Error('No response body');
      }

      const decoder = new TextDecoder();
      let buffer = '';

      while (true) {
        const { done, value } = await reader.read();

        if (done) {
          if (offCallback) {
            offCallback({ data: null, code: 1000, reason: 'Stream completed' });
          }
          break;
        }

        buffer += decoder.decode(value, { stream: true });
        const lines = buffer.split('\n');
        buffer = lines.pop() || '';

        for (const line of lines) {
          if (line.startsWith('data: ')) {
            try {
              const data = line.slice(6);
              const parsed = JSON.parse(data);

              if (parsed.errors) {
                if (errorCallback) {
                  errorCallback({ data: parsed.data, errors: parsed.errors });
                }
              } else if (onCallback && parsed.data) {
                onCallback(parsed.data);
              }
            } catch {
              if (errorCallback) {
                errorCallback({ errors: ['Failed to parse SSE data'] });
              }
            }
          }
        }
      }
    } catch (err: unknown) {
      const error = err as Error;
      if (error.name !== 'AbortError' && errorCallback) {
        errorCallback({ errors: [error.message || 'Unknown error'] });
      }
    }
  };

  return {
    on: (e: (args: unknown) => void) => {
      onCallback = e;
    },
    off: (e: (args: unknown) => void) => {
      offCallback = e;
    },
    error: (e: (args: unknown) => void) => {
      errorCallback = e;
    },
    open: (e?: () => void) => {
      if (e) {
        openCallback = e;
      }
      startStream();
    },
    close: () => {
      if (abortController) {
        abortController.abort();
      }
      if (reader) {
        reader.cancel();
      }
    },
  };
};
const handleFetchResponse = (response: Response): Promise<GraphQLResponse> => {
  if (!response.ok) {
    return new Promise((_, reject) => {
      response
        .text()
        .then((text) => {
          try {
            reject(JSON.parse(text));
          } catch (err) {
            reject(text);
          }
        })
        .catch(reject);
    });
  }
  return response.json() as Promise<GraphQLResponse>;
};

export const apiFetch =
  (options: fetchOptions) =>
  (query: string, variables: Record<string, unknown> = {}) => {
    const fetchOptions = options[1] || {};
    if (fetchOptions.method && fetchOptions.method === 'GET') {
      return fetch(`${options[0]}?query=${encodeURIComponent(query)}`, fetchOptions)
        .then(handleFetchResponse)
        .then((response: GraphQLResponse) => {
          if (response.errors) {
            throw new GraphQLError(response);
          }
          return response.data;
        });
    }
    return fetch(`${options[0]}`, {
      body: JSON.stringify({ query, variables }),
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      ...fetchOptions,
    })
      .then(handleFetchResponse)
      .then((response: GraphQLResponse) => {
        if (response.errors) {
          throw new GraphQLError(response);
        }
        return response.data;
      });
  };

export const InternalsBuildQuery = ({
  ops,
  props,
  returns,
  options,
  scalars,
}: {
  props: AllTypesPropsType;
  returns: ReturnTypesType;
  ops: Operations;
  options?: OperationOptions;
  scalars?: ScalarDefinition;
}) => {
  const ibb = (
    k: string,
    o: InputValueType | VType,
    p = '',
    root = true,
    vars: Array<{ name: string; graphQLType: string }> = [],
  ): string => {
    const keyForPath = purifyGraphQLKey(k);
    const newPath = [p, keyForPath].join(SEPARATOR);
    if (!o) {
      return '';
    }
    if (typeof o === 'boolean' || typeof o === 'number') {
      return k;
    }
    if (typeof o === 'string') {
      return `${k} ${o}`;
    }
    if (Array.isArray(o)) {
      const args = InternalArgsBuilt({
        props,
        returns,
        ops,
        scalars,
        vars,
      })(o[0], newPath);
      return `${ibb(args ? `${k}(${args})` : k, o[1], p, false, vars)}`;
    }
    if (k === '__alias') {
      return Object.entries(o)
        .map(([alias, objectUnderAlias]) => {
          if (typeof objectUnderAlias !== 'object' || Array.isArray(objectUnderAlias)) {
            throw new Error(
              'Invalid alias it should be __alias:{ YOUR_ALIAS_NAME: { OPERATION_NAME: { ...selectors }}}',
            );
          }
          const operationName = Object.keys(objectUnderAlias)[0];
          const operation = objectUnderAlias[operationName];
          return ibb(`${alias}:${operationName}`, operation, p, false, vars);
        })
        .join('\n');
    }
    const hasOperationName = root && options?.operationName ? ' ' + options.operationName : '';
    const keyForDirectives = o.__directives ?? '';
    const query = `{${Object.entries(o)
      .filter(([k]) => k !== '__directives')
      .map((e) => ibb(...e, [p, `field<>${keyForPath}`].join(SEPARATOR), false, vars))
      .join('\n')}}`;
    if (!root) {
      return `${k} ${keyForDirectives}${hasOperationName} ${query}`;
    }
    const varsString = vars.map((v) => `${v.name}: ${v.graphQLType}`).join(', ');
    return `${k} ${keyForDirectives}${hasOperationName}${varsString ? `(${varsString})` : ''} ${query}`;
  };
  return ibb;
};

type UnionOverrideKeys<T, U> = Omit<T, keyof U> & U;

export const Thunder =
  <SCLR extends ScalarDefinition>(fn: FetchFunction, thunderGraphQLOptions?: ThunderGraphQLOptions<SCLR>) =>
  <O extends keyof typeof Ops, OVERRIDESCLR extends SCLR, R extends keyof ValueTypes = GenericOperation<O>>(
    operation: O,
    graphqlOptions?: ThunderGraphQLOptions<OVERRIDESCLR>,
  ) =>
  <Z extends ValueTypes[R]>(
    o: Z & {
      [P in keyof Z]: P extends keyof ValueTypes[R] ? Z[P] : never;
    },
    ops?: OperationOptions & { variables?: Record<string, unknown> },
  ) => {
    const options = {
      ...thunderGraphQLOptions,
      ...graphqlOptions,
    };
    return fn(
      Zeus(operation, o, {
        operationOptions: ops,
        scalars: options?.scalars,
      }),
      ops?.variables,
    ).then((data) => {
      if (options?.scalars) {
        return decodeScalarsInResponse({
          response: data,
          initialOp: operation,
          initialZeusQuery: o as VType,
          returns: ReturnTypes,
          scalars: options.scalars,
          ops: Ops,
        });
      }
      return data;
    }) as Promise<InputType<GraphQLTypes[R], Z, UnionOverrideKeys<SCLR, OVERRIDESCLR>>>;
  };

export const Chain = (...options: chainOptions) => Thunder(apiFetch(options));

export const SubscriptionThunder =
  <SCLR extends ScalarDefinition>(fn: SubscriptionFunction, thunderGraphQLOptions?: ThunderGraphQLOptions<SCLR>) =>
  <O extends keyof typeof Ops, OVERRIDESCLR extends SCLR, R extends keyof ValueTypes = GenericOperation<O>>(
    operation: O,
    graphqlOptions?: ThunderGraphQLOptions<OVERRIDESCLR>,
  ) =>
  <Z extends ValueTypes[R]>(
    o: Z & {
      [P in keyof Z]: P extends keyof ValueTypes[R] ? Z[P] : never;
    },
    ops?: OperationOptions & { variables?: Record<string, unknown> },
  ) => {
    const options = {
      ...thunderGraphQLOptions,
      ...graphqlOptions,
    };
    type CombinedSCLR = UnionOverrideKeys<SCLR, OVERRIDESCLR>;
    const returnedFunction = fn(
      Zeus(operation, o, {
        operationOptions: ops,
        scalars: options?.scalars,
      }),
    ) as SubscriptionToGraphQL<Z, GraphQLTypes[R], CombinedSCLR>;
    if (returnedFunction?.on && options?.scalars) {
      const wrapped = returnedFunction.on;
      returnedFunction.on = (fnToCall: (args: InputType<GraphQLTypes[R], Z, CombinedSCLR>) => void) =>
        wrapped((data: InputType<GraphQLTypes[R], Z, CombinedSCLR>) => {
          if (options?.scalars) {
            return fnToCall(
              decodeScalarsInResponse({
                response: data,
                initialOp: operation,
                initialZeusQuery: o as VType,
                returns: ReturnTypes,
                scalars: options.scalars,
                ops: Ops,
              }),
            );
          }
          return fnToCall(data);
        });
    }
    return returnedFunction;
  };

export const Subscription = (...options: chainOptions) => SubscriptionThunder(apiSubscription(options));
export type SubscriptionToGraphQLSSE<Z, T, SCLR extends ScalarDefinition> = {
  on: (fn: (args: InputType<T, Z, SCLR>) => void) => void;
  off: (fn: (e: { data?: InputType<T, Z, SCLR>; code?: number; reason?: string; message?: string }) => void) => void;
  error: (fn: (e: { data?: InputType<T, Z, SCLR>; errors?: string[] }) => void) => void;
  open: (fn?: () => void) => void;
  close: () => void;
};

export const SubscriptionThunderSSE =
  <SCLR extends ScalarDefinition>(fn: SubscriptionFunction, thunderGraphQLOptions?: ThunderGraphQLOptions<SCLR>) =>
  <O extends keyof typeof Ops, OVERRIDESCLR extends SCLR, R extends keyof ValueTypes = GenericOperation<O>>(
    operation: O,
    graphqlOptions?: ThunderGraphQLOptions<OVERRIDESCLR>,
  ) =>
  <Z extends ValueTypes[R]>(
    o: Z & {
      [P in keyof Z]: P extends keyof ValueTypes[R] ? Z[P] : never;
    },
    ops?: OperationOptions & { variables?: Record<string, unknown> },
  ) => {
    const options = {
      ...thunderGraphQLOptions,
      ...graphqlOptions,
    };
    type CombinedSCLR = UnionOverrideKeys<SCLR, OVERRIDESCLR>;
    const returnedFunction = fn(
      Zeus(operation, o, {
        operationOptions: ops,
        scalars: options?.scalars,
      }), ops?.variables
    ) as SubscriptionToGraphQLSSE<Z, GraphQLTypes[R], CombinedSCLR>;
    if (returnedFunction?.on && options?.scalars) {
      const wrapped = returnedFunction.on;
      returnedFunction.on = (fnToCall: (args: InputType<GraphQLTypes[R], Z, CombinedSCLR>) => void) =>
        wrapped((data: InputType<GraphQLTypes[R], Z, CombinedSCLR>) => {
          if (options?.scalars) {
            return fnToCall(
              decodeScalarsInResponse({
                response: data,
                initialOp: operation,
                initialZeusQuery: o as VType,
                returns: ReturnTypes,
                scalars: options.scalars,
                ops: Ops,
              }),
            );
          }
          return fnToCall(data);
        });
    }
    return returnedFunction;
  };
export const SubscriptionSSE = (...options: chainOptions) => SubscriptionThunderSSE(apiSubscriptionSSE(options));
export const Zeus = <
  Z extends ValueTypes[R],
  O extends keyof typeof Ops,
  R extends keyof ValueTypes = GenericOperation<O>,
>(
  operation: O,
  o: Z,
  ops?: {
    operationOptions?: OperationOptions;
    scalars?: ScalarDefinition;
  },
) =>
  InternalsBuildQuery({
    props: AllTypesProps,
    returns: ReturnTypes,
    ops: Ops,
    options: ops?.operationOptions,
    scalars: ops?.scalars,
  })(operation, o as VType);

export const ZeusSelect = <T>() => ((t: unknown) => t) as SelectionFunction<T>;

export const Selector = <T extends keyof ValueTypes>(key: T) => key && ZeusSelect<ValueTypes[T]>();

export const TypeFromSelector = <T extends keyof ValueTypes>(key: T) => key && ZeusSelect<ValueTypes[T]>();
export const Gql = Chain(HOST, {
  headers: {
    'Content-Type': 'application/json',
    ...HEADERS,
  },
});

export const ZeusScalars = ZeusSelect<ScalarCoders>();

type BaseSymbol = number | string | undefined | boolean | null;

type ScalarsSelector<T, V> = {
  [X in Required<{
    [P in keyof T]: P extends keyof V
      ? V[P] extends Array<any> | undefined
        ? never
        : T[P] extends BaseSymbol | Array<BaseSymbol>
        ? P
        : never
      : never;
  }>[keyof T]]: true;
};

export const fields = <T extends keyof ModelTypes>(k: T) => {
  const t = ReturnTypes[k];
  const fnType = k in AllTypesProps ? AllTypesProps[k as keyof typeof AllTypesProps] : undefined;
  const hasFnTypes = typeof fnType === 'object' ? fnType : undefined;
  const o = Object.fromEntries(
    Object.entries(t)
      .filter(([k, value]) => {
        const isFunctionType = hasFnTypes && k in hasFnTypes && !!hasFnTypes[k as keyof typeof hasFnTypes];
        if (isFunctionType) return false;
        const isReturnType = ReturnTypes[value as string];
        if (!isReturnType) return true;
        if (typeof isReturnType !== 'string') return false;
        if (isReturnType.startsWith('scalar.')) {
          return true;
        }
        return false;
      })
      .map(([key]) => [key, true as const]),
  );
  return o as ScalarsSelector<ModelTypes[T], T extends keyof ValueTypes ? ValueTypes[T] : never>;
};

export const decodeScalarsInResponse = <O extends Operations>({
  response,
  scalars,
  returns,
  ops,
  initialZeusQuery,
  initialOp,
}: {
  ops: O;
  response: any;
  returns: ReturnTypesType;
  scalars?: Record<string, ScalarResolver | undefined>;
  initialOp: keyof O;
  initialZeusQuery: InputValueType | VType;
}) => {
  if (!scalars) {
    return response;
  }
  const builder = PrepareScalarPaths({
    ops,
    returns,
  });

  const scalarPaths = builder(initialOp as string, ops[initialOp], initialZeusQuery);
  if (scalarPaths) {
    const r = traverseResponse({ scalarPaths, resolvers: scalars })(initialOp as string, response, [ops[initialOp]]);
    return r;
  }
  return response;
};

export const traverseResponse = ({
  resolvers,
  scalarPaths,
}: {
  scalarPaths: { [x: string]: `scalar.${string}` };
  resolvers: {
    [x: string]: ScalarResolver | undefined;
  };
}) => {
  const ibb = (k: string, o: InputValueType | VType, p: string[] = []): unknown => {
    if (Array.isArray(o)) {
      return o.map((eachO) => ibb(k, eachO, p));
    }
    if (o == null) {
      return o;
    }
    const scalarPathString = p.join(SEPARATOR);
    const currentScalarString = scalarPaths[scalarPathString];
    if (currentScalarString) {
      const currentDecoder = resolvers[currentScalarString.split('.')[1]]?.decode;
      if (currentDecoder) {
        return currentDecoder(o);
      }
    }
    if (typeof o === 'boolean' || typeof o === 'number' || typeof o === 'string' || !o) {
      return o;
    }
    const entries = Object.entries(o).map(([k, v]) => [k, ibb(k, v, [...p, purifyGraphQLKey(k)])] as const);
    const objectFromEntries = entries.reduce<Record<string, unknown>>((a, [k, v]) => {
      a[k] = v;
      return a;
    }, {});
    return objectFromEntries;
  };
  return ibb;
};

export type AllTypesPropsType = {
  [x: string]:
    | undefined
    | `scalar.${string}`
    | 'enum'
    | {
        [x: string]:
          | undefined
          | string
          | {
              [x: string]: string | undefined;
            };
      };
};

export type ReturnTypesType = {
  [x: string]:
    | {
        [x: string]: string | undefined;
      }
    | `scalar.${string}`
    | undefined;
};
export type InputValueType = {
  [x: string]: undefined | boolean | string | number | [any, undefined | boolean | InputValueType] | InputValueType;
};
export type VType =
  | undefined
  | boolean
  | string
  | number
  | [any, undefined | boolean | InputValueType]
  | InputValueType;

export type PlainType = boolean | number | string | null | undefined;
export type ZeusArgsType =
  | PlainType
  | {
      [x: string]: ZeusArgsType;
    }
  | Array<ZeusArgsType>;

export type Operations = Record<string, string>;

export type VariableDefinition = {
  [x: string]: unknown;
};

export const SEPARATOR = '|';

export type fetchOptions = Parameters<typeof fetch>;
type websocketOptions = typeof WebSocket extends new (...args: infer R) => WebSocket ? R : never;
export type chainOptions = [fetchOptions[0], fetchOptions[1] & { websocket?: websocketOptions }] | [fetchOptions[0]];
export type FetchFunction = (query: string, variables?: Record<string, unknown>) => Promise<any>;
export type SubscriptionFunction = (query: string, variables?: Record<string, unknown>) => any;
type NotUndefined<T> = T extends undefined ? never : T;
export type ResolverType<F> = NotUndefined<F extends [infer ARGS, any] ? ARGS : undefined>;

export type OperationOptions = {
  operationName?: string;
};

export type ScalarCoder = Record<string, (s: unknown) => string>;

export interface GraphQLResponse {
  data?: Record<string, any>;
  errors?: Array<{
    message: string;
  }>;
}
export class GraphQLError extends Error {
  constructor(public response: GraphQLResponse) {
    super('');
    console.error(response);
  }
  toString() {
    return 'GraphQL Response Error';
  }
}
export type GenericOperation<O> = O extends keyof typeof Ops ? typeof Ops[O] : never;
export type ThunderGraphQLOptions<SCLR extends ScalarDefinition> = {
  scalars?: SCLR | ScalarCoders;
};

const ExtractScalar = (mappedParts: string[], returns: ReturnTypesType): `scalar.${string}` | undefined => {
  if (mappedParts.length === 0) {
    return;
  }
  const oKey = mappedParts[0];
  const returnP1 = returns[oKey];
  if (typeof returnP1 === 'object') {
    const returnP2 = returnP1[mappedParts[1]];
    if (returnP2) {
      return ExtractScalar([returnP2, ...mappedParts.slice(2)], returns);
    }
    return undefined;
  }
  return returnP1 as `scalar.${string}` | undefined;
};

export const PrepareScalarPaths = ({ ops, returns }: { returns: ReturnTypesType; ops: Operations }) => {
  const ibb = (
    k: string,
    originalKey: string,
    o: InputValueType | VType,
    p: string[] = [],
    pOriginals: string[] = [],
    root = true,
  ): { [x: string]: `scalar.${string}` } | undefined => {
    if (!o) {
      return;
    }
    if (typeof o === 'boolean' || typeof o === 'number' || typeof o === 'string') {
      const extractionArray = [...pOriginals, originalKey];
      const isScalar = ExtractScalar(extractionArray, returns);
      if (isScalar?.startsWith('scalar')) {
        const partOfTree = {
          [[...p, k].join(SEPARATOR)]: isScalar,
        };
        return partOfTree;
      }
      return {};
    }
    if (Array.isArray(o)) {
      return ibb(k, k, o[1], p, pOriginals, false);
    }
    if (k === '__alias') {
      return Object.entries(o)
        .map(([alias, objectUnderAlias]) => {
          if (typeof objectUnderAlias !== 'object' || Array.isArray(objectUnderAlias)) {
            throw new Error(
              'Invalid alias it should be __alias:{ YOUR_ALIAS_NAME: { OPERATION_NAME: { ...selectors }}}',
            );
          }
          const operationName = Object.keys(objectUnderAlias)[0];
          const operation = objectUnderAlias[operationName];
          return ibb(alias, operationName, operation, p, pOriginals, false);
        })
        .reduce((a, b) => ({
          ...a,
          ...b,
        }));
    }
    const keyName = root ? ops[k] : k;
    return Object.entries(o)
      .filter(([k]) => k !== '__directives')
      .map(([k, v]) => {
        // Inline fragments shouldn't be added to the path as they aren't a field
        const isInlineFragment = originalKey.match(/^...\s*on/) != null;
        return ibb(
          k,
          k,
          v,
          isInlineFragment ? p : [...p, purifyGraphQLKey(keyName || k)],
          isInlineFragment ? pOriginals : [...pOriginals, purifyGraphQLKey(originalKey)],
          false,
        );
      })
      .reduce((a, b) => ({
        ...a,
        ...b,
      }));
  };
  return ibb;
};

export const purifyGraphQLKey = (k: string) => k.replace(/\([^)]*\)/g, '').replace(/^[^:]*\:/g, '');

const mapPart = (p: string) => {
  const [isArg, isField] = p.split('<>');
  if (isField) {
    return {
      v: isField,
      __type: 'field',
    } as const;
  }
  return {
    v: isArg,
    __type: 'arg',
  } as const;
};

type Part = ReturnType<typeof mapPart>;

export const ResolveFromPath = (props: AllTypesPropsType, returns: ReturnTypesType, ops: Operations) => {
  const ResolvePropsType = (mappedParts: Part[]) => {
    const oKey = ops[mappedParts[0].v];
    const propsP1 = oKey ? props[oKey] : props[mappedParts[0].v];
    if (propsP1 === 'enum' && mappedParts.length === 1) {
      return 'enum';
    }
    if (typeof propsP1 === 'string' && propsP1.startsWith('scalar.') && mappedParts.length === 1) {
      return propsP1;
    }
    if (typeof propsP1 === 'object') {
      if (mappedParts.length < 2) {
        return 'not';
      }
      const propsP2 = propsP1[mappedParts[1].v];
      if (typeof propsP2 === 'string') {
        return rpp(
          `${propsP2}${SEPARATOR}${mappedParts
            .slice(2)
            .map((mp) => mp.v)
            .join(SEPARATOR)}`,
        );
      }
      if (typeof propsP2 === 'object') {
        if (mappedParts.length < 3) {
          return 'not';
        }
        const propsP3 = propsP2[mappedParts[2].v];
        if (propsP3 && mappedParts[2].__type === 'arg') {
          return rpp(
            `${propsP3}${SEPARATOR}${mappedParts
              .slice(3)
              .map((mp) => mp.v)
              .join(SEPARATOR)}`,
          );
        }
      }
    }
  };
  const ResolveReturnType = (mappedParts: Part[]) => {
    if (mappedParts.length === 0) {
      return 'not';
    }
    const oKey = ops[mappedParts[0].v];
    const returnP1 = oKey ? returns[oKey] : returns[mappedParts[0].v];
    if (typeof returnP1 === 'object') {
      if (mappedParts.length < 2) return 'not';
      const returnP2 = returnP1[mappedParts[1].v];
      if (returnP2) {
        return rpp(
          `${returnP2}${SEPARATOR}${mappedParts
            .slice(2)
            .map((mp) => mp.v)
            .join(SEPARATOR)}`,
        );
      }
    }
  };
  const rpp = (path: string): 'enum' | 'not' | `scalar.${string}` => {
    const parts = path.split(SEPARATOR).filter((l) => l.length > 0);
    const mappedParts = parts.map(mapPart);
    const propsP1 = ResolvePropsType(mappedParts);
    if (propsP1) {
      return propsP1;
    }
    const returnP1 = ResolveReturnType(mappedParts);
    if (returnP1) {
      return returnP1;
    }
    return 'not';
  };
  return rpp;
};

export const InternalArgsBuilt = ({
  props,
  ops,
  returns,
  scalars,
  vars,
}: {
  props: AllTypesPropsType;
  returns: ReturnTypesType;
  ops: Operations;
  scalars?: ScalarDefinition;
  vars: Array<{ name: string; graphQLType: string }>;
}) => {
  const arb = (a: ZeusArgsType, p = '', root = true): string => {
    if (typeof a === 'string') {
      if (a.startsWith(START_VAR_NAME)) {
        const [varName, graphQLType] = a.replace(START_VAR_NAME, '$').split(GRAPHQL_TYPE_SEPARATOR);
        const v = vars.find((v) => v.name === varName);
        if (!v) {
          vars.push({
            name: varName,
            graphQLType,
          });
        } else {
          if (v.graphQLType !== graphQLType) {
            throw new Error(
              `Invalid variable exists with two different GraphQL Types, "${v.graphQLType}" and ${graphQLType}`,
            );
          }
        }
        return varName;
      }
    }
    const checkType = ResolveFromPath(props, returns, ops)(p);
    if (checkType.startsWith('scalar.')) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const [_, ...splittedScalar] = checkType.split('.');
      const scalarKey = splittedScalar.join('.');
      return (scalars?.[scalarKey]?.encode?.(a) as string) || JSON.stringify(a);
    }
    if (Array.isArray(a)) {
      return `[${a.map((arr) => arb(arr, p, false)).join(', ')}]`;
    }
    if (typeof a === 'string') {
      if (checkType === 'enum') {
        return a;
      }
      return `${JSON.stringify(a)}`;
    }
    if (typeof a === 'object') {
      if (a === null) {
        return `null`;
      }
      const returnedObjectString = Object.entries(a)
        .filter(([, v]) => typeof v !== 'undefined')
        .map(([k, v]) => `${k}: ${arb(v, [p, k].join(SEPARATOR), false)}`)
        .join(',\n');
      if (!root) {
        return `{${returnedObjectString}}`;
      }
      return returnedObjectString;
    }
    return `${a}`;
  };
  return arb;
};

export const resolverFor = <X, T extends keyof ResolverInputTypes, Z extends keyof ResolverInputTypes[T]>(
  _type: T,
  _field: Z,
  fn: (
    args: Required<ResolverInputTypes[T]>[Z] extends [infer Input, any] ? Input : any,
    source: any,
  ) => Z extends keyof ModelTypes[T] ? ModelTypes[T][Z] | Promise<ModelTypes[T][Z]> | X : never,
) => fn as (args?: any, source?: any) => ReturnType<typeof fn>;

export type UnwrapPromise<T> = T extends Promise<infer R> ? R : T;
export type ZeusState<T extends (...args: any[]) => Promise<any>> = NonNullable<UnwrapPromise<ReturnType<T>>>;
export type ZeusHook<
  T extends (...args: any[]) => Record<string, (...args: any[]) => Promise<any>>,
  N extends keyof ReturnType<T>,
> = ZeusState<ReturnType<T>[N]>;

export type WithTypeNameValue<T> = T & {
  __typename?: boolean;
  __directives?: string;
};
export type AliasType<T> = WithTypeNameValue<T> & {
  __alias?: Record<string, WithTypeNameValue<T>>;
};
type DeepAnify<T> = {
  [P in keyof T]?: any;
};
type IsPayLoad<T> = T extends [any, infer PayLoad] ? PayLoad : T;
export type ScalarDefinition = Record<string, ScalarResolver>;

type IsScalar<S, SCLR extends ScalarDefinition> = S extends 'scalar' & { name: infer T }
  ? T extends keyof SCLR
    ? SCLR[T]['decode'] extends (s: unknown) => unknown
      ? ReturnType<SCLR[T]['decode']>
      : unknown
    : unknown
  : S extends Array<infer R>
  ? Array<IsScalar<R, SCLR>>
  : S;

type IsArray<T, U, SCLR extends ScalarDefinition> = T extends Array<infer R>
  ? InputType<R, U, SCLR>[]
  : InputType<T, U, SCLR>;
type FlattenArray<T> = T extends Array<infer R> ? R : T;
type BaseZeusResolver = boolean | 1 | string | Variable<any, string>;

type IsInterfaced<SRC extends DeepAnify<DST>, DST, SCLR extends ScalarDefinition> = FlattenArray<SRC> extends
  | ZEUS_INTERFACES
  | ZEUS_UNIONS
  ? {
      [P in keyof SRC]: SRC[P] extends '__union' & infer R
        ? P extends keyof DST
          ? IsArray<R, '__typename' extends keyof DST ? DST[P] & { __typename: true } : DST[P], SCLR>
          : IsArray<R, '__typename' extends keyof DST ? { __typename: true } : Record<string, never>, SCLR>
        : never;
    }[keyof SRC] & {
      [P in keyof Omit<
        Pick<
          SRC,
          {
            [P in keyof DST]: SRC[P] extends '__union' & infer _R ? never : P;
          }[keyof DST]
        >,
        '__typename'
      >]: IsPayLoad<DST[P]> extends BaseZeusResolver ? IsScalar<SRC[P], SCLR> : IsArray<SRC[P], DST[P], SCLR>;
    }
  : {
      [P in keyof Pick<SRC, keyof DST>]: IsPayLoad<DST[P]> extends BaseZeusResolver
        ? IsScalar<SRC[P], SCLR>
        : IsArray<SRC[P], DST[P], SCLR>;
    };

export type MapType<SRC, DST, SCLR extends ScalarDefinition> = SRC extends DeepAnify<DST>
  ? IsInterfaced<SRC, DST, SCLR>
  : never;
// eslint-disable-next-line @typescript-eslint/ban-types
export type InputType<SRC, DST, SCLR extends ScalarDefinition = {}> = IsPayLoad<DST> extends { __alias: infer R }
  ? {
      [P in keyof R]: MapType<SRC, R[P], SCLR>[keyof MapType<SRC, R[P], SCLR>];
    } & MapType<SRC, Omit<IsPayLoad<DST>, '__alias'>, SCLR>
  : MapType<SRC, IsPayLoad<DST>, SCLR>;
export type SubscriptionToGraphQL<Z, T, SCLR extends ScalarDefinition> = {
  ws: WebSocket;
  on: (fn: (args: InputType<T, Z, SCLR>) => void) => void;
  off: (fn: (e: { data?: InputType<T, Z, SCLR>; code?: number; reason?: string; message?: string }) => void) => void;
  error: (fn: (e: { data?: InputType<T, Z, SCLR>; errors?: string[] }) => void) => void;
  open: () => void;
};

// eslint-disable-next-line @typescript-eslint/ban-types
export type FromSelector<SELECTOR, NAME extends keyof GraphQLTypes, SCLR extends ScalarDefinition = {}> = InputType<
  GraphQLTypes[NAME],
  SELECTOR,
  SCLR
>;

export type ScalarResolver = {
  encode?: (s: unknown) => string;
  decode?: (s: unknown) => unknown;
};

export type SelectionFunction<V> = <Z extends V>(
  t: Z & {
    [P in keyof Z]: P extends keyof V ? Z[P] : never;
  },
) => Z;

type BuiltInVariableTypes = {
  ['String']: string;
  ['Int']: number;
  ['Float']: number;
  ['Boolean']: boolean;
};
type AllVariableTypes = keyof BuiltInVariableTypes | keyof ZEUS_VARIABLES;
type VariableRequired<T extends string> = `${T}!` | T | `[${T}]` | `[${T}]!` | `[${T}!]` | `[${T}!]!`;
type VR<T extends string> = VariableRequired<VariableRequired<T>>;

export type GraphQLVariableType = VR<AllVariableTypes>;

type ExtractVariableTypeString<T extends string> = T extends VR<infer R1>
  ? R1 extends VR<infer R2>
    ? R2 extends VR<infer R3>
      ? R3 extends VR<infer R4>
        ? R4 extends VR<infer R5>
          ? R5
          : R4
        : R3
      : R2
    : R1
  : T;

type DecomposeType<T, Type> = T extends `[${infer R}]`
  ? Array<DecomposeType<R, Type>> | undefined
  : T extends `${infer R}!`
  ? NonNullable<DecomposeType<R, Type>>
  : Type | undefined;

type ExtractTypeFromGraphQLType<T extends string> = T extends keyof ZEUS_VARIABLES
  ? ZEUS_VARIABLES[T]
  : T extends keyof BuiltInVariableTypes
  ? BuiltInVariableTypes[T]
  : any;

export type GetVariableType<T extends string> = DecomposeType<
  T,
  ExtractTypeFromGraphQLType<ExtractVariableTypeString<T>>
>;

type UndefinedKeys<T> = {
  [K in keyof T]-?: T[K] extends NonNullable<T[K]> ? never : K;
}[keyof T];

type WithNullableKeys<T> = Pick<T, UndefinedKeys<T>>;
type WithNonNullableKeys<T> = Omit<T, UndefinedKeys<T>>;

type OptionalKeys<T> = {
  [P in keyof T]?: T[P];
};

export type WithOptionalNullables<T> = OptionalKeys<WithNullableKeys<T>> & WithNonNullableKeys<T>;

export type ComposableSelector<T extends keyof ValueTypes> = ReturnType<SelectionFunction<ValueTypes[T]>>;

export type Variable<T extends GraphQLVariableType, Name extends string> = {
  ' __zeus_name': Name;
  ' __zeus_type': T;
};

export type ExtractVariablesDeep<Query> = Query extends Variable<infer VType, infer VName>
  ? { [key in VName]: GetVariableType<VType> }
  : Query extends string | number | boolean | Array<string | number | boolean>
  ? // eslint-disable-next-line @typescript-eslint/ban-types
    {}
  : UnionToIntersection<{ [K in keyof Query]: WithOptionalNullables<ExtractVariablesDeep<Query[K]>> }[keyof Query]>;

export type ExtractVariables<Query> = Query extends Variable<infer VType, infer VName>
  ? { [key in VName]: GetVariableType<VType> }
  : Query extends [infer Inputs, infer Outputs]
  ? ExtractVariablesDeep<Inputs> & ExtractVariables<Outputs>
  : Query extends string | number | boolean | Array<string | number | boolean>
  ? // eslint-disable-next-line @typescript-eslint/ban-types
    {}
  : UnionToIntersection<{ [K in keyof Query]: WithOptionalNullables<ExtractVariables<Query[K]>> }[keyof Query]>;

type UnionToIntersection<U> = (U extends any ? (k: U) => void : never) extends (k: infer I) => void ? I : never;

export const START_VAR_NAME = `$ZEUS_VAR`;
export const GRAPHQL_TYPE_SEPARATOR = `__$GRAPHQL__`;

export const $ = <Type extends GraphQLVariableType, Name extends string>(name: Name, graphqlType: Type) => {
  return (START_VAR_NAME + name + GRAPHQL_TYPE_SEPARATOR + graphqlType) as unknown as Variable<Type, Name>;
};
type ZEUS_INTERFACES = never
export type ScalarCoders = {
	DateTime?: ScalarResolver;
	ID?: ScalarResolver;
}
type ZEUS_UNIONS = GraphQLTypes["AuthType"]

export type ValueTypes = {
    ["Permissions"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	roles?:ValueTypes["Role"],
		__typename?: boolean | `@${string}`,
	['...on Permissions']?: Omit<ValueTypes["Permissions"], "...on Permissions">
}>;
	/** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
["DateTime"]:unknown;
	["Users"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	password?:boolean | `@${string}`,
	passwordResetToken?:boolean | `@${string}`,
	passwordResetExpiryDate?:boolean | `@${string}`,
	activateAccountToken?:boolean | `@${string}`,
	activateAccountExpiryDate?:boolean | `@${string}`,
	emailVerified?:boolean | `@${string}`,
	verifyEmailToken?:boolean | `@${string}`,
	verifyEmailExpiryDate?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	refreshToken?:boolean | `@${string}`,
	role?:ValueTypes["Role"],
	roleId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on Users']?: Omit<ValueTypes["Users"], "...on Users">
}>;
	["AccountStatus"]:AccountStatus;
	["UserPagination"]: AliasType<{
	users?:ValueTypes["Users"],
	total?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on UserPagination']?: Omit<ValueTypes["UserPagination"], "...on UserPagination">
}>;
	["Role"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	permissions?:ValueTypes["Permissions"],
	users?:ValueTypes["Users"],
		__typename?: boolean | `@${string}`,
	['...on Role']?: Omit<ValueTypes["Role"], "...on Role">
}>;
	["UniqueAuth"]: AliasType<{
	access_token?:boolean | `@${string}`,
	refresh_token?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	role?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on UniqueAuth']?: Omit<ValueTypes["UniqueAuth"], "...on UniqueAuth">
}>;
	["UserInfo"]: AliasType<{
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	roles?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on UserInfo']?: Omit<ValueTypes["UserInfo"], "...on UserInfo">
}>;
	["RoleEnum"]:RoleEnum;
	["DownloadFile"]: AliasType<{
	fileName?:boolean | `@${string}`,
	fileMimeType?:boolean | `@${string}`,
	url?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on DownloadFile']?: Omit<ValueTypes["DownloadFile"], "...on DownloadFile">
}>;
	["MyFiles"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	eTag?:boolean | `@${string}`,
	location?:boolean | `@${string}`,
	fileName?:boolean | `@${string}`,
	fileMimeType?:boolean | `@${string}`,
	ownerId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on MyFiles']?: Omit<ValueTypes["MyFiles"], "...on MyFiles">
}>;
	["UploadPreSignedUrl"]: AliasType<{
	url?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on UploadPreSignedUrl']?: Omit<ValueTypes["UploadPreSignedUrl"], "...on UploadPreSignedUrl">
}>;
	["Mail"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	key?:boolean | `@${string}`,
	to?:boolean | `@${string}`,
	data?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on Mail']?: Omit<ValueTypes["Mail"], "...on Mail">
}>;
	["ScormTrackingModel"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	completionStatus?:boolean | `@${string}`,
	successStatus?:boolean | `@${string}`,
	scoreRaw?:boolean | `@${string}`,
	scoreMin?:boolean | `@${string}`,
	scoreMax?:boolean | `@${string}`,
	scoreScaled?:boolean | `@${string}`,
	totalTime?:boolean | `@${string}`,
	sessionTime?:boolean | `@${string}`,
	suspendData?:boolean | `@${string}`,
	location?:boolean | `@${string}`,
	completedAt?:boolean | `@${string}`,
	userId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on ScormTrackingModel']?: Omit<ValueTypes["ScormTrackingModel"], "...on ScormTrackingModel">
}>;
	["ScormCompletionStatus"]:ScormCompletionStatus;
	["ScormSuccessStatus"]:ScormSuccessStatus;
	["ScormTrackingWithUser"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	completionStatus?:boolean | `@${string}`,
	successStatus?:boolean | `@${string}`,
	scoreRaw?:boolean | `@${string}`,
	scoreMin?:boolean | `@${string}`,
	scoreMax?:boolean | `@${string}`,
	scoreScaled?:boolean | `@${string}`,
	totalTime?:boolean | `@${string}`,
	sessionTime?:boolean | `@${string}`,
	suspendData?:boolean | `@${string}`,
	location?:boolean | `@${string}`,
	completedAt?:boolean | `@${string}`,
	userId?:boolean | `@${string}`,
	userEmail?:boolean | `@${string}`,
	userFirstName?:boolean | `@${string}`,
	userLastName?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on ScormTrackingWithUser']?: Omit<ValueTypes["ScormTrackingWithUser"], "...on ScormTrackingWithUser">
}>;
	["ScormTrackingPagination"]: AliasType<{
	trackings?:ValueTypes["ScormTrackingWithUser"],
	total?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on ScormTrackingPagination']?: Omit<ValueTypes["ScormTrackingPagination"], "...on ScormTrackingPagination">
}>;
	["Health"]: AliasType<{
	env?:boolean | `@${string}`,
	time?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	version?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on Health']?: Omit<ValueTypes["Health"], "...on Health">
}>;
	["Query"]: AliasType<{
	getHealthGql?:ValueTypes["Health"],
getRole?: [{	id: string | Variable<any, string>},ValueTypes["Role"]],
	getRoles?:ValueTypes["Role"],
getPermission?: [{	id: string | Variable<any, string>},ValueTypes["Permissions"]],
	getPermissions?:ValueTypes["Permissions"],
getMail?: [{	id: string | Variable<any, string>},ValueTypes["Mail"]],
	getMails?:ValueTypes["Mail"],
	sendMail?:boolean | `@${string}`,
loginAsGuest?: [{	email: string | Variable<any, string>},ValueTypes["AuthType"]],
uniqueAuthFromSso?: [{	code: string | Variable<any, string>},ValueTypes["UniqueAuth"]],
	me?:ValueTypes["UserInfo"],
getUser?: [{	id: string | Variable<any, string>},ValueTypes["Users"]],
	getUsers?:ValueTypes["Users"],
getFilteredUsers?: [{	findManyUserWithFiltersInput: ValueTypes["FindManyUserWithFiltersInput"] | Variable<any, string>},ValueTypes["UserPagination"]],
	getMyScormTracking?:ValueTypes["ScormTrackingModel"],
getScormTrackings?: [{	input: ValueTypes["FindManyScormTrackingWithFiltersInput"] | Variable<any, string>},ValueTypes["ScormTrackingPagination"]],
downloadFile?: [{	eTag: string | Variable<any, string>},ValueTypes["DownloadFile"]],
	getAllMyFiles?:ValueTypes["MyFiles"],
publishBasicSubscription?: [{	from: string | Variable<any, string>,	to: string | Variable<any, string>},boolean | `@${string}`],
		__typename?: boolean | `@${string}`,
	['...on Query']?: Omit<ValueTypes["Query"], "...on Query">
}>;
	["AuthType"]: AliasType<{		["...on UserInfo"]?: ValueTypes["UserInfo"],
		["...on CustomError"]?: ValueTypes["CustomError"]
		__typename?: boolean | `@${string}`
}>;
	["CustomError"]: AliasType<{
	error?:boolean | `@${string}`,
	message?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`,
	['...on CustomError']?: Omit<ValueTypes["CustomError"], "...on CustomError">
}>;
	["EError"]:EError;
	["FindManyUserWithFiltersInput"]: {
	skip: number | Variable<any, string>,
	take: number | Variable<any, string>,
	searchInput: string | Variable<any, string>,
	orderBy?: ValueTypes["UserOrderByInput"] | undefined | null | Variable<any, string>,
	filterBy?: ValueTypes["UserFilterByInput"] | undefined | null | Variable<any, string>
};
	["UserOrderByInput"]: {
	email?: ValueTypes["OrderByEnum"] | undefined | null | Variable<any, string>,
	firstName?: ValueTypes["OrderByEnum"] | undefined | null | Variable<any, string>,
	lastName?: ValueTypes["OrderByEnum"] | undefined | null | Variable<any, string>,
	lastConnectionAt?: ValueTypes["OrderByEnum"] | undefined | null | Variable<any, string>,
	role?: ValueTypes["OrderByEnum"] | undefined | null | Variable<any, string>
};
	["OrderByEnum"]:OrderByEnum;
	["UserFilterByInput"]: {
	role?: Array<string> | undefined | null | Variable<any, string>
};
	["FindManyScormTrackingWithFiltersInput"]: {
	skip: number | Variable<any, string>,
	take: number | Variable<any, string>,
	searchInput?: string | undefined | null | Variable<any, string>,
	orderBy?: ValueTypes["ScormTrackingOrderByInput"] | undefined | null | Variable<any, string>,
	filterBy?: ValueTypes["ScormTrackingFilterByInput"] | undefined | null | Variable<any, string>
};
	["ScormTrackingOrderByInput"]: {
	userEmail?: ValueTypes["OrderByEnum"] | undefined | null | Variable<any, string>,
	userFirstName?: ValueTypes["OrderByEnum"] | undefined | null | Variable<any, string>,
	userLastName?: ValueTypes["OrderByEnum"] | undefined | null | Variable<any, string>,
	completionStatus?: ValueTypes["OrderByEnum"] | undefined | null | Variable<any, string>,
	successStatus?: ValueTypes["OrderByEnum"] | undefined | null | Variable<any, string>,
	scoreRaw?: ValueTypes["OrderByEnum"] | undefined | null | Variable<any, string>,
	completedAt?: ValueTypes["OrderByEnum"] | undefined | null | Variable<any, string>
};
	["ScormTrackingFilterByInput"]: {
	completionStatus?: ValueTypes["ScormCompletionStatus"] | undefined | null | Variable<any, string>,
	successStatus?: ValueTypes["ScormSuccessStatus"] | undefined | null | Variable<any, string>
};
	["Mutation"]: AliasType<{
login?: [{	email: string | Variable<any, string>,	password: string | Variable<any, string>},ValueTypes["AuthType"]],
askForResetPassword?: [{	email: string | Variable<any, string>},boolean | `@${string}`],
reSendEmailValidation?: [{	email: string | Variable<any, string>},boolean | `@${string}`],
resetPassword?: [{	email: string | Variable<any, string>,	password: string | Variable<any, string>,	token: string | Variable<any, string>},boolean | `@${string}`],
verifyEmail?: [{	email: string | Variable<any, string>,	token: string | Variable<any, string>},boolean | `@${string}`],
register?: [{	email: string | Variable<any, string>,	password: string | Variable<any, string>,	firstName: string | Variable<any, string>,	lastName: string | Variable<any, string>},ValueTypes["AuthType"]],
askForRegister?: [{	registerUserInput: ValueTypes["RegisterUserInput"] | Variable<any, string>},boolean | `@${string}`],
finishRegister?: [{	email: string | Variable<any, string>,	password: string | Variable<any, string>,	firstName: string | Variable<any, string>,	lastName: string | Variable<any, string>,	token: string | Variable<any, string>},boolean | `@${string}`],
finishRegisterAsGuest?: [{	email: string | Variable<any, string>,	password: string | Variable<any, string>,	firstName: string | Variable<any, string>,	lastName: string | Variable<any, string>},boolean | `@${string}`],
	refresh?:ValueTypes["AuthType"],
	logout?:boolean | `@${string}`,
impersonateUser?: [{	userId: string | Variable<any, string>},ValueTypes["AuthType"]],
createUser?: [{	createUserInput: ValueTypes["CreateUserInput"] | Variable<any, string>},ValueTypes["Users"]],
updateUser?: [{	updateUserInput: ValueTypes["UpdateUserInput"] | Variable<any, string>},ValueTypes["Users"]],
deleteUser?: [{	id: string | Variable<any, string>},boolean | `@${string}`],
upsertScormTracking?: [{	input: ValueTypes["UpsertScormTrackingInput"] | Variable<any, string>},ValueTypes["ScormTrackingModel"]],
deleteFile?: [{	fileId: string | Variable<any, string>},boolean | `@${string}`],
uploadPreSignedUrl?: [{	mimeType: string | Variable<any, string>,	fileName: string | Variable<any, string>},ValueTypes["UploadPreSignedUrl"]],
confirmUpload?: [{	id: string | Variable<any, string>,	status: boolean | Variable<any, string>},boolean | `@${string}`],
		__typename?: boolean | `@${string}`,
	['...on Mutation']?: Omit<ValueTypes["Mutation"], "...on Mutation">
}>;
	["RegisterUserInput"]: {
	email: string | Variable<any, string>,
	roleId: string | Variable<any, string>
};
	["CreateUserInput"]: {
	email: string | Variable<any, string>,
	password: string | Variable<any, string>,
	firstName: string | Variable<any, string>,
	lastName: string | Variable<any, string>,
	roleId: string | Variable<any, string>
};
	["UpdateUserInput"]: {
	email?: string | undefined | null | Variable<any, string>,
	firstName?: string | undefined | null | Variable<any, string>,
	lastName?: string | undefined | null | Variable<any, string>,
	roleId?: string | undefined | null | Variable<any, string>,
	id: string | Variable<any, string>
};
	["UpsertScormTrackingInput"]: {
	completionStatus?: ValueTypes["ScormCompletionStatus"] | undefined | null | Variable<any, string>,
	successStatus?: ValueTypes["ScormSuccessStatus"] | undefined | null | Variable<any, string>,
	scoreRaw?: number | undefined | null | Variable<any, string>,
	scoreMin?: number | undefined | null | Variable<any, string>,
	scoreMax?: number | undefined | null | Variable<any, string>,
	scoreScaled?: number | undefined | null | Variable<any, string>,
	totalTime?: string | undefined | null | Variable<any, string>,
	sessionTime?: string | undefined | null | Variable<any, string>,
	suspendData?: string | undefined | null | Variable<any, string>,
	location?: string | undefined | null | Variable<any, string>
};
	["Subscription"]: AliasType<{
basicSubscription?: [{	email: string | Variable<any, string>},boolean | `@${string}`],
		__typename?: boolean | `@${string}`,
	['...on Subscription']?: Omit<ValueTypes["Subscription"], "...on Subscription">
}>;
	["ID"]:unknown
  }

export type ResolverInputTypes = {
    ["Permissions"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	roles?:ResolverInputTypes["Role"],
		__typename?: boolean | `@${string}`
}>;
	/** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
["DateTime"]:unknown;
	["Users"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	password?:boolean | `@${string}`,
	passwordResetToken?:boolean | `@${string}`,
	passwordResetExpiryDate?:boolean | `@${string}`,
	activateAccountToken?:boolean | `@${string}`,
	activateAccountExpiryDate?:boolean | `@${string}`,
	emailVerified?:boolean | `@${string}`,
	verifyEmailToken?:boolean | `@${string}`,
	verifyEmailExpiryDate?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	refreshToken?:boolean | `@${string}`,
	role?:ResolverInputTypes["Role"],
	roleId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["AccountStatus"]:AccountStatus;
	["UserPagination"]: AliasType<{
	users?:ResolverInputTypes["Users"],
	total?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Role"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	permissions?:ResolverInputTypes["Permissions"],
	users?:ResolverInputTypes["Users"],
		__typename?: boolean | `@${string}`
}>;
	["UniqueAuth"]: AliasType<{
	access_token?:boolean | `@${string}`,
	refresh_token?:boolean | `@${string}`,
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	role?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["UserInfo"]: AliasType<{
	firstName?:boolean | `@${string}`,
	lastName?:boolean | `@${string}`,
	roles?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["RoleEnum"]:RoleEnum;
	["DownloadFile"]: AliasType<{
	fileName?:boolean | `@${string}`,
	fileMimeType?:boolean | `@${string}`,
	url?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["MyFiles"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	eTag?:boolean | `@${string}`,
	location?:boolean | `@${string}`,
	fileName?:boolean | `@${string}`,
	fileMimeType?:boolean | `@${string}`,
	ownerId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["UploadPreSignedUrl"]: AliasType<{
	url?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Mail"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	key?:boolean | `@${string}`,
	to?:boolean | `@${string}`,
	data?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ScormTrackingModel"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	completionStatus?:boolean | `@${string}`,
	successStatus?:boolean | `@${string}`,
	scoreRaw?:boolean | `@${string}`,
	scoreMin?:boolean | `@${string}`,
	scoreMax?:boolean | `@${string}`,
	scoreScaled?:boolean | `@${string}`,
	totalTime?:boolean | `@${string}`,
	sessionTime?:boolean | `@${string}`,
	suspendData?:boolean | `@${string}`,
	location?:boolean | `@${string}`,
	completedAt?:boolean | `@${string}`,
	userId?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ScormCompletionStatus"]:ScormCompletionStatus;
	["ScormSuccessStatus"]:ScormSuccessStatus;
	["ScormTrackingWithUser"]: AliasType<{
	id?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	updatedAt?:boolean | `@${string}`,
	completionStatus?:boolean | `@${string}`,
	successStatus?:boolean | `@${string}`,
	scoreRaw?:boolean | `@${string}`,
	scoreMin?:boolean | `@${string}`,
	scoreMax?:boolean | `@${string}`,
	scoreScaled?:boolean | `@${string}`,
	totalTime?:boolean | `@${string}`,
	sessionTime?:boolean | `@${string}`,
	suspendData?:boolean | `@${string}`,
	location?:boolean | `@${string}`,
	completedAt?:boolean | `@${string}`,
	userId?:boolean | `@${string}`,
	userEmail?:boolean | `@${string}`,
	userFirstName?:boolean | `@${string}`,
	userLastName?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ScormTrackingPagination"]: AliasType<{
	trackings?:ResolverInputTypes["ScormTrackingWithUser"],
	total?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Health"]: AliasType<{
	env?:boolean | `@${string}`,
	time?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	version?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Query"]: AliasType<{
	getHealthGql?:ResolverInputTypes["Health"],
getRole?: [{	id: string},ResolverInputTypes["Role"]],
	getRoles?:ResolverInputTypes["Role"],
getPermission?: [{	id: string},ResolverInputTypes["Permissions"]],
	getPermissions?:ResolverInputTypes["Permissions"],
getMail?: [{	id: string},ResolverInputTypes["Mail"]],
	getMails?:ResolverInputTypes["Mail"],
	sendMail?:boolean | `@${string}`,
loginAsGuest?: [{	email: string},ResolverInputTypes["AuthType"]],
uniqueAuthFromSso?: [{	code: string},ResolverInputTypes["UniqueAuth"]],
	me?:ResolverInputTypes["UserInfo"],
getUser?: [{	id: string},ResolverInputTypes["Users"]],
	getUsers?:ResolverInputTypes["Users"],
getFilteredUsers?: [{	findManyUserWithFiltersInput: ResolverInputTypes["FindManyUserWithFiltersInput"]},ResolverInputTypes["UserPagination"]],
	getMyScormTracking?:ResolverInputTypes["ScormTrackingModel"],
getScormTrackings?: [{	input: ResolverInputTypes["FindManyScormTrackingWithFiltersInput"]},ResolverInputTypes["ScormTrackingPagination"]],
downloadFile?: [{	eTag: string},ResolverInputTypes["DownloadFile"]],
	getAllMyFiles?:ResolverInputTypes["MyFiles"],
publishBasicSubscription?: [{	from: string,	to: string},boolean | `@${string}`],
		__typename?: boolean | `@${string}`
}>;
	["AuthType"]: AliasType<{
	UserInfo?:ResolverInputTypes["UserInfo"],
	CustomError?:ResolverInputTypes["CustomError"],
		__typename?: boolean | `@${string}`
}>;
	["CustomError"]: AliasType<{
	error?:boolean | `@${string}`,
	message?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["EError"]:EError;
	["FindManyUserWithFiltersInput"]: {
	skip: number,
	take: number,
	searchInput: string,
	orderBy?: ResolverInputTypes["UserOrderByInput"] | undefined | null,
	filterBy?: ResolverInputTypes["UserFilterByInput"] | undefined | null
};
	["UserOrderByInput"]: {
	email?: ResolverInputTypes["OrderByEnum"] | undefined | null,
	firstName?: ResolverInputTypes["OrderByEnum"] | undefined | null,
	lastName?: ResolverInputTypes["OrderByEnum"] | undefined | null,
	lastConnectionAt?: ResolverInputTypes["OrderByEnum"] | undefined | null,
	role?: ResolverInputTypes["OrderByEnum"] | undefined | null
};
	["OrderByEnum"]:OrderByEnum;
	["UserFilterByInput"]: {
	role?: Array<string> | undefined | null
};
	["FindManyScormTrackingWithFiltersInput"]: {
	skip: number,
	take: number,
	searchInput?: string | undefined | null,
	orderBy?: ResolverInputTypes["ScormTrackingOrderByInput"] | undefined | null,
	filterBy?: ResolverInputTypes["ScormTrackingFilterByInput"] | undefined | null
};
	["ScormTrackingOrderByInput"]: {
	userEmail?: ResolverInputTypes["OrderByEnum"] | undefined | null,
	userFirstName?: ResolverInputTypes["OrderByEnum"] | undefined | null,
	userLastName?: ResolverInputTypes["OrderByEnum"] | undefined | null,
	completionStatus?: ResolverInputTypes["OrderByEnum"] | undefined | null,
	successStatus?: ResolverInputTypes["OrderByEnum"] | undefined | null,
	scoreRaw?: ResolverInputTypes["OrderByEnum"] | undefined | null,
	completedAt?: ResolverInputTypes["OrderByEnum"] | undefined | null
};
	["ScormTrackingFilterByInput"]: {
	completionStatus?: ResolverInputTypes["ScormCompletionStatus"] | undefined | null,
	successStatus?: ResolverInputTypes["ScormSuccessStatus"] | undefined | null
};
	["Mutation"]: AliasType<{
login?: [{	email: string,	password: string},ResolverInputTypes["AuthType"]],
askForResetPassword?: [{	email: string},boolean | `@${string}`],
reSendEmailValidation?: [{	email: string},boolean | `@${string}`],
resetPassword?: [{	email: string,	password: string,	token: string},boolean | `@${string}`],
verifyEmail?: [{	email: string,	token: string},boolean | `@${string}`],
register?: [{	email: string,	password: string,	firstName: string,	lastName: string},ResolverInputTypes["AuthType"]],
askForRegister?: [{	registerUserInput: ResolverInputTypes["RegisterUserInput"]},boolean | `@${string}`],
finishRegister?: [{	email: string,	password: string,	firstName: string,	lastName: string,	token: string},boolean | `@${string}`],
finishRegisterAsGuest?: [{	email: string,	password: string,	firstName: string,	lastName: string},boolean | `@${string}`],
	refresh?:ResolverInputTypes["AuthType"],
	logout?:boolean | `@${string}`,
impersonateUser?: [{	userId: string},ResolverInputTypes["AuthType"]],
createUser?: [{	createUserInput: ResolverInputTypes["CreateUserInput"]},ResolverInputTypes["Users"]],
updateUser?: [{	updateUserInput: ResolverInputTypes["UpdateUserInput"]},ResolverInputTypes["Users"]],
deleteUser?: [{	id: string},boolean | `@${string}`],
upsertScormTracking?: [{	input: ResolverInputTypes["UpsertScormTrackingInput"]},ResolverInputTypes["ScormTrackingModel"]],
deleteFile?: [{	fileId: string},boolean | `@${string}`],
uploadPreSignedUrl?: [{	mimeType: string,	fileName: string},ResolverInputTypes["UploadPreSignedUrl"]],
confirmUpload?: [{	id: string,	status: boolean},boolean | `@${string}`],
		__typename?: boolean | `@${string}`
}>;
	["RegisterUserInput"]: {
	email: string,
	roleId: string
};
	["CreateUserInput"]: {
	email: string,
	password: string,
	firstName: string,
	lastName: string,
	roleId: string
};
	["UpdateUserInput"]: {
	email?: string | undefined | null,
	firstName?: string | undefined | null,
	lastName?: string | undefined | null,
	roleId?: string | undefined | null,
	id: string
};
	["UpsertScormTrackingInput"]: {
	completionStatus?: ResolverInputTypes["ScormCompletionStatus"] | undefined | null,
	successStatus?: ResolverInputTypes["ScormSuccessStatus"] | undefined | null,
	scoreRaw?: number | undefined | null,
	scoreMin?: number | undefined | null,
	scoreMax?: number | undefined | null,
	scoreScaled?: number | undefined | null,
	totalTime?: string | undefined | null,
	sessionTime?: string | undefined | null,
	suspendData?: string | undefined | null,
	location?: string | undefined | null
};
	["Subscription"]: AliasType<{
basicSubscription?: [{	email: string},boolean | `@${string}`],
		__typename?: boolean | `@${string}`
}>;
	["schema"]: AliasType<{
	query?:ResolverInputTypes["Query"],
	mutation?:ResolverInputTypes["Mutation"],
	subscription?:ResolverInputTypes["Subscription"],
		__typename?: boolean | `@${string}`
}>;
	["ID"]:unknown
  }

export type ModelTypes = {
    ["Permissions"]: {
		id: ModelTypes["ID"],
	createdAt: ModelTypes["DateTime"],
	updatedAt: ModelTypes["DateTime"],
	name: string,
	roles: Array<ModelTypes["Role"]>
};
	/** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
["DateTime"]:any;
	["Users"]: {
		id: ModelTypes["ID"],
	createdAt: ModelTypes["DateTime"],
	updatedAt: ModelTypes["DateTime"],
	status: ModelTypes["AccountStatus"],
	email: string,
	password: string,
	passwordResetToken?: string | undefined | null,
	passwordResetExpiryDate?: ModelTypes["DateTime"] | undefined | null,
	activateAccountToken?: string | undefined | null,
	activateAccountExpiryDate?: ModelTypes["DateTime"] | undefined | null,
	emailVerified: boolean,
	verifyEmailToken?: string | undefined | null,
	verifyEmailExpiryDate?: ModelTypes["DateTime"] | undefined | null,
	firstName: string,
	lastName: string,
	refreshToken?: string | undefined | null,
	role: ModelTypes["Role"],
	roleId: string
};
	["AccountStatus"]:AccountStatus;
	["UserPagination"]: {
		users: Array<ModelTypes["Users"] | undefined | null>,
	total: number
};
	["Role"]: {
		id: ModelTypes["ID"],
	createdAt: ModelTypes["DateTime"],
	updatedAt: ModelTypes["DateTime"],
	name: string,
	permissions: Array<ModelTypes["Permissions"] | undefined | null>,
	users: Array<ModelTypes["Users"] | undefined | null>
};
	["UniqueAuth"]: {
		access_token: string,
	refresh_token: string,
	firstName: string,
	lastName: string,
	role: string,
	email: string,
	id: string
};
	["UserInfo"]: {
		firstName: string,
	lastName: string,
	roles: ModelTypes["RoleEnum"],
	email: string,
	id: string
};
	["RoleEnum"]:RoleEnum;
	["DownloadFile"]: {
		fileName: string,
	fileMimeType: string,
	url: string
};
	["MyFiles"]: {
		id: string,
	createdAt: ModelTypes["DateTime"],
	updatedAt: ModelTypes["DateTime"],
	eTag: string,
	location: string,
	fileName: string,
	fileMimeType: string,
	ownerId: string
};
	["UploadPreSignedUrl"]: {
		url: string,
	id: string
};
	["Mail"]: {
		id: ModelTypes["ID"],
	createdAt: ModelTypes["DateTime"],
	updatedAt: ModelTypes["DateTime"],
	key: string,
	to: string,
	data: string
};
	["ScormTrackingModel"]: {
		id: ModelTypes["ID"],
	createdAt: ModelTypes["DateTime"],
	updatedAt: ModelTypes["DateTime"],
	completionStatus: ModelTypes["ScormCompletionStatus"],
	successStatus: ModelTypes["ScormSuccessStatus"],
	scoreRaw?: number | undefined | null,
	scoreMin?: number | undefined | null,
	scoreMax?: number | undefined | null,
	scoreScaled?: number | undefined | null,
	totalTime?: string | undefined | null,
	sessionTime?: string | undefined | null,
	suspendData?: string | undefined | null,
	location?: string | undefined | null,
	completedAt?: ModelTypes["DateTime"] | undefined | null,
	userId: string
};
	["ScormCompletionStatus"]:ScormCompletionStatus;
	["ScormSuccessStatus"]:ScormSuccessStatus;
	["ScormTrackingWithUser"]: {
		id: ModelTypes["ID"],
	createdAt: ModelTypes["DateTime"],
	updatedAt: ModelTypes["DateTime"],
	completionStatus: ModelTypes["ScormCompletionStatus"],
	successStatus: ModelTypes["ScormSuccessStatus"],
	scoreRaw?: number | undefined | null,
	scoreMin?: number | undefined | null,
	scoreMax?: number | undefined | null,
	scoreScaled?: number | undefined | null,
	totalTime?: string | undefined | null,
	sessionTime?: string | undefined | null,
	suspendData?: string | undefined | null,
	location?: string | undefined | null,
	completedAt?: ModelTypes["DateTime"] | undefined | null,
	userId: string,
	userEmail: string,
	userFirstName: string,
	userLastName: string
};
	["ScormTrackingPagination"]: {
		trackings: Array<ModelTypes["ScormTrackingWithUser"] | undefined | null>,
	total: number
};
	["Health"]: {
		env: string,
	time: string,
	status: string,
	version: string
};
	["Query"]: {
		getHealthGql: ModelTypes["Health"],
	getRole: ModelTypes["Role"],
	getRoles: Array<ModelTypes["Role"]>,
	getPermission: ModelTypes["Permissions"],
	getPermissions: Array<ModelTypes["Permissions"]>,
	getMail: ModelTypes["Mail"],
	getMails: Array<ModelTypes["Mail"]>,
	sendMail: boolean,
	loginAsGuest: ModelTypes["AuthType"],
	uniqueAuthFromSso: ModelTypes["UniqueAuth"],
	me: ModelTypes["UserInfo"],
	getUser: ModelTypes["Users"],
	getUsers: Array<ModelTypes["Users"]>,
	getFilteredUsers: ModelTypes["UserPagination"],
	getMyScormTracking?: ModelTypes["ScormTrackingModel"] | undefined | null,
	getScormTrackings: ModelTypes["ScormTrackingPagination"],
	downloadFile: ModelTypes["DownloadFile"],
	getAllMyFiles: Array<ModelTypes["MyFiles"]>,
	publishBasicSubscription: boolean
};
	["AuthType"]:ModelTypes["UserInfo"] | ModelTypes["CustomError"];
	["CustomError"]: {
		error: ModelTypes["EError"],
	message: string
};
	["EError"]:EError;
	["FindManyUserWithFiltersInput"]: {
	skip: number,
	take: number,
	searchInput: string,
	orderBy?: ModelTypes["UserOrderByInput"] | undefined | null,
	filterBy?: ModelTypes["UserFilterByInput"] | undefined | null
};
	["UserOrderByInput"]: {
	email?: ModelTypes["OrderByEnum"] | undefined | null,
	firstName?: ModelTypes["OrderByEnum"] | undefined | null,
	lastName?: ModelTypes["OrderByEnum"] | undefined | null,
	lastConnectionAt?: ModelTypes["OrderByEnum"] | undefined | null,
	role?: ModelTypes["OrderByEnum"] | undefined | null
};
	["OrderByEnum"]:OrderByEnum;
	["UserFilterByInput"]: {
	role?: Array<string> | undefined | null
};
	["FindManyScormTrackingWithFiltersInput"]: {
	skip: number,
	take: number,
	searchInput?: string | undefined | null,
	orderBy?: ModelTypes["ScormTrackingOrderByInput"] | undefined | null,
	filterBy?: ModelTypes["ScormTrackingFilterByInput"] | undefined | null
};
	["ScormTrackingOrderByInput"]: {
	userEmail?: ModelTypes["OrderByEnum"] | undefined | null,
	userFirstName?: ModelTypes["OrderByEnum"] | undefined | null,
	userLastName?: ModelTypes["OrderByEnum"] | undefined | null,
	completionStatus?: ModelTypes["OrderByEnum"] | undefined | null,
	successStatus?: ModelTypes["OrderByEnum"] | undefined | null,
	scoreRaw?: ModelTypes["OrderByEnum"] | undefined | null,
	completedAt?: ModelTypes["OrderByEnum"] | undefined | null
};
	["ScormTrackingFilterByInput"]: {
	completionStatus?: ModelTypes["ScormCompletionStatus"] | undefined | null,
	successStatus?: ModelTypes["ScormSuccessStatus"] | undefined | null
};
	["Mutation"]: {
		login: ModelTypes["AuthType"],
	askForResetPassword: boolean,
	reSendEmailValidation: boolean,
	resetPassword: boolean,
	verifyEmail: boolean,
	register: ModelTypes["AuthType"],
	askForRegister: boolean,
	finishRegister: boolean,
	finishRegisterAsGuest: boolean,
	refresh: ModelTypes["AuthType"],
	logout: boolean,
	impersonateUser: ModelTypes["AuthType"],
	createUser: ModelTypes["Users"],
	updateUser: ModelTypes["Users"],
	deleteUser: boolean,
	upsertScormTracking: ModelTypes["ScormTrackingModel"],
	deleteFile: boolean,
	uploadPreSignedUrl: ModelTypes["UploadPreSignedUrl"],
	confirmUpload: boolean
};
	["RegisterUserInput"]: {
	email: string,
	roleId: string
};
	["CreateUserInput"]: {
	email: string,
	password: string,
	firstName: string,
	lastName: string,
	roleId: string
};
	["UpdateUserInput"]: {
	email?: string | undefined | null,
	firstName?: string | undefined | null,
	lastName?: string | undefined | null,
	roleId?: string | undefined | null,
	id: string
};
	["UpsertScormTrackingInput"]: {
	completionStatus?: ModelTypes["ScormCompletionStatus"] | undefined | null,
	successStatus?: ModelTypes["ScormSuccessStatus"] | undefined | null,
	scoreRaw?: number | undefined | null,
	scoreMin?: number | undefined | null,
	scoreMax?: number | undefined | null,
	scoreScaled?: number | undefined | null,
	totalTime?: string | undefined | null,
	sessionTime?: string | undefined | null,
	suspendData?: string | undefined | null,
	location?: string | undefined | null
};
	["Subscription"]: {
		basicSubscription?: string | undefined | null
};
	["schema"]: {
	query?: ModelTypes["Query"] | undefined | null,
	mutation?: ModelTypes["Mutation"] | undefined | null,
	subscription?: ModelTypes["Subscription"] | undefined | null
};
	["ID"]:any
    }

export type GraphQLTypes = {
    // ------------------------------------------------------;
	// THIS FILE WAS AUTOMATICALLY GENERATED (DO NOT MODIFY);
	// ------------------------------------------------------;
	["Permissions"]: {
	__typename: "Permissions",
	id: GraphQLTypes["ID"],
	createdAt: GraphQLTypes["DateTime"],
	updatedAt: GraphQLTypes["DateTime"],
	name: string,
	roles: Array<GraphQLTypes["Role"]>,
	['...on Permissions']: Omit<GraphQLTypes["Permissions"], "...on Permissions">
};
	/** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
["DateTime"]: "scalar" & { name: "DateTime" };
	["Users"]: {
	__typename: "Users",
	id: GraphQLTypes["ID"],
	createdAt: GraphQLTypes["DateTime"],
	updatedAt: GraphQLTypes["DateTime"],
	status: GraphQLTypes["AccountStatus"],
	email: string,
	password: string,
	passwordResetToken?: string | undefined | null,
	passwordResetExpiryDate?: GraphQLTypes["DateTime"] | undefined | null,
	activateAccountToken?: string | undefined | null,
	activateAccountExpiryDate?: GraphQLTypes["DateTime"] | undefined | null,
	emailVerified: boolean,
	verifyEmailToken?: string | undefined | null,
	verifyEmailExpiryDate?: GraphQLTypes["DateTime"] | undefined | null,
	firstName: string,
	lastName: string,
	refreshToken?: string | undefined | null,
	role: GraphQLTypes["Role"],
	roleId: string,
	['...on Users']: Omit<GraphQLTypes["Users"], "...on Users">
};
	["AccountStatus"]: AccountStatus;
	["UserPagination"]: {
	__typename: "UserPagination",
	users: Array<GraphQLTypes["Users"] | undefined | null>,
	total: number,
	['...on UserPagination']: Omit<GraphQLTypes["UserPagination"], "...on UserPagination">
};
	["Role"]: {
	__typename: "Role",
	id: GraphQLTypes["ID"],
	createdAt: GraphQLTypes["DateTime"],
	updatedAt: GraphQLTypes["DateTime"],
	name: string,
	permissions: Array<GraphQLTypes["Permissions"] | undefined | null>,
	users: Array<GraphQLTypes["Users"] | undefined | null>,
	['...on Role']: Omit<GraphQLTypes["Role"], "...on Role">
};
	["UniqueAuth"]: {
	__typename: "UniqueAuth",
	access_token: string,
	refresh_token: string,
	firstName: string,
	lastName: string,
	role: string,
	email: string,
	id: string,
	['...on UniqueAuth']: Omit<GraphQLTypes["UniqueAuth"], "...on UniqueAuth">
};
	["UserInfo"]: {
	__typename: "UserInfo",
	firstName: string,
	lastName: string,
	roles: GraphQLTypes["RoleEnum"],
	email: string,
	id: string,
	['...on UserInfo']: Omit<GraphQLTypes["UserInfo"], "...on UserInfo">
};
	["RoleEnum"]: RoleEnum;
	["DownloadFile"]: {
	__typename: "DownloadFile",
	fileName: string,
	fileMimeType: string,
	url: string,
	['...on DownloadFile']: Omit<GraphQLTypes["DownloadFile"], "...on DownloadFile">
};
	["MyFiles"]: {
	__typename: "MyFiles",
	id: string,
	createdAt: GraphQLTypes["DateTime"],
	updatedAt: GraphQLTypes["DateTime"],
	eTag: string,
	location: string,
	fileName: string,
	fileMimeType: string,
	ownerId: string,
	['...on MyFiles']: Omit<GraphQLTypes["MyFiles"], "...on MyFiles">
};
	["UploadPreSignedUrl"]: {
	__typename: "UploadPreSignedUrl",
	url: string,
	id: string,
	['...on UploadPreSignedUrl']: Omit<GraphQLTypes["UploadPreSignedUrl"], "...on UploadPreSignedUrl">
};
	["Mail"]: {
	__typename: "Mail",
	id: GraphQLTypes["ID"],
	createdAt: GraphQLTypes["DateTime"],
	updatedAt: GraphQLTypes["DateTime"],
	key: string,
	to: string,
	data: string,
	['...on Mail']: Omit<GraphQLTypes["Mail"], "...on Mail">
};
	["ScormTrackingModel"]: {
	__typename: "ScormTrackingModel",
	id: GraphQLTypes["ID"],
	createdAt: GraphQLTypes["DateTime"],
	updatedAt: GraphQLTypes["DateTime"],
	completionStatus: GraphQLTypes["ScormCompletionStatus"],
	successStatus: GraphQLTypes["ScormSuccessStatus"],
	scoreRaw?: number | undefined | null,
	scoreMin?: number | undefined | null,
	scoreMax?: number | undefined | null,
	scoreScaled?: number | undefined | null,
	totalTime?: string | undefined | null,
	sessionTime?: string | undefined | null,
	suspendData?: string | undefined | null,
	location?: string | undefined | null,
	completedAt?: GraphQLTypes["DateTime"] | undefined | null,
	userId: string,
	['...on ScormTrackingModel']: Omit<GraphQLTypes["ScormTrackingModel"], "...on ScormTrackingModel">
};
	["ScormCompletionStatus"]: ScormCompletionStatus;
	["ScormSuccessStatus"]: ScormSuccessStatus;
	["ScormTrackingWithUser"]: {
	__typename: "ScormTrackingWithUser",
	id: GraphQLTypes["ID"],
	createdAt: GraphQLTypes["DateTime"],
	updatedAt: GraphQLTypes["DateTime"],
	completionStatus: GraphQLTypes["ScormCompletionStatus"],
	successStatus: GraphQLTypes["ScormSuccessStatus"],
	scoreRaw?: number | undefined | null,
	scoreMin?: number | undefined | null,
	scoreMax?: number | undefined | null,
	scoreScaled?: number | undefined | null,
	totalTime?: string | undefined | null,
	sessionTime?: string | undefined | null,
	suspendData?: string | undefined | null,
	location?: string | undefined | null,
	completedAt?: GraphQLTypes["DateTime"] | undefined | null,
	userId: string,
	userEmail: string,
	userFirstName: string,
	userLastName: string,
	['...on ScormTrackingWithUser']: Omit<GraphQLTypes["ScormTrackingWithUser"], "...on ScormTrackingWithUser">
};
	["ScormTrackingPagination"]: {
	__typename: "ScormTrackingPagination",
	trackings: Array<GraphQLTypes["ScormTrackingWithUser"] | undefined | null>,
	total: number,
	['...on ScormTrackingPagination']: Omit<GraphQLTypes["ScormTrackingPagination"], "...on ScormTrackingPagination">
};
	["Health"]: {
	__typename: "Health",
	env: string,
	time: string,
	status: string,
	version: string,
	['...on Health']: Omit<GraphQLTypes["Health"], "...on Health">
};
	["Query"]: {
	__typename: "Query",
	getHealthGql: GraphQLTypes["Health"],
	getRole: GraphQLTypes["Role"],
	getRoles: Array<GraphQLTypes["Role"]>,
	getPermission: GraphQLTypes["Permissions"],
	getPermissions: Array<GraphQLTypes["Permissions"]>,
	getMail: GraphQLTypes["Mail"],
	getMails: Array<GraphQLTypes["Mail"]>,
	sendMail: boolean,
	loginAsGuest: GraphQLTypes["AuthType"],
	uniqueAuthFromSso: GraphQLTypes["UniqueAuth"],
	me: GraphQLTypes["UserInfo"],
	getUser: GraphQLTypes["Users"],
	getUsers: Array<GraphQLTypes["Users"]>,
	getFilteredUsers: GraphQLTypes["UserPagination"],
	getMyScormTracking?: GraphQLTypes["ScormTrackingModel"] | undefined | null,
	getScormTrackings: GraphQLTypes["ScormTrackingPagination"],
	downloadFile: GraphQLTypes["DownloadFile"],
	getAllMyFiles: Array<GraphQLTypes["MyFiles"]>,
	publishBasicSubscription: boolean,
	['...on Query']: Omit<GraphQLTypes["Query"], "...on Query">
};
	["AuthType"]:{
        	__typename:"UserInfo" | "CustomError"
        	['...on UserInfo']: '__union' & GraphQLTypes["UserInfo"];
	['...on CustomError']: '__union' & GraphQLTypes["CustomError"];
};
	["CustomError"]: {
	__typename: "CustomError",
	error: GraphQLTypes["EError"],
	message: string,
	['...on CustomError']: Omit<GraphQLTypes["CustomError"], "...on CustomError">
};
	["EError"]: EError;
	["FindManyUserWithFiltersInput"]: {
		skip: number,
	take: number,
	searchInput: string,
	orderBy?: GraphQLTypes["UserOrderByInput"] | undefined | null,
	filterBy?: GraphQLTypes["UserFilterByInput"] | undefined | null
};
	["UserOrderByInput"]: {
		email?: GraphQLTypes["OrderByEnum"] | undefined | null,
	firstName?: GraphQLTypes["OrderByEnum"] | undefined | null,
	lastName?: GraphQLTypes["OrderByEnum"] | undefined | null,
	lastConnectionAt?: GraphQLTypes["OrderByEnum"] | undefined | null,
	role?: GraphQLTypes["OrderByEnum"] | undefined | null
};
	["OrderByEnum"]: OrderByEnum;
	["UserFilterByInput"]: {
		role?: Array<string> | undefined | null
};
	["FindManyScormTrackingWithFiltersInput"]: {
		skip: number,
	take: number,
	searchInput?: string | undefined | null,
	orderBy?: GraphQLTypes["ScormTrackingOrderByInput"] | undefined | null,
	filterBy?: GraphQLTypes["ScormTrackingFilterByInput"] | undefined | null
};
	["ScormTrackingOrderByInput"]: {
		userEmail?: GraphQLTypes["OrderByEnum"] | undefined | null,
	userFirstName?: GraphQLTypes["OrderByEnum"] | undefined | null,
	userLastName?: GraphQLTypes["OrderByEnum"] | undefined | null,
	completionStatus?: GraphQLTypes["OrderByEnum"] | undefined | null,
	successStatus?: GraphQLTypes["OrderByEnum"] | undefined | null,
	scoreRaw?: GraphQLTypes["OrderByEnum"] | undefined | null,
	completedAt?: GraphQLTypes["OrderByEnum"] | undefined | null
};
	["ScormTrackingFilterByInput"]: {
		completionStatus?: GraphQLTypes["ScormCompletionStatus"] | undefined | null,
	successStatus?: GraphQLTypes["ScormSuccessStatus"] | undefined | null
};
	["Mutation"]: {
	__typename: "Mutation",
	login: GraphQLTypes["AuthType"],
	askForResetPassword: boolean,
	reSendEmailValidation: boolean,
	resetPassword: boolean,
	verifyEmail: boolean,
	register: GraphQLTypes["AuthType"],
	askForRegister: boolean,
	finishRegister: boolean,
	finishRegisterAsGuest: boolean,
	refresh: GraphQLTypes["AuthType"],
	logout: boolean,
	impersonateUser: GraphQLTypes["AuthType"],
	createUser: GraphQLTypes["Users"],
	updateUser: GraphQLTypes["Users"],
	deleteUser: boolean,
	upsertScormTracking: GraphQLTypes["ScormTrackingModel"],
	deleteFile: boolean,
	uploadPreSignedUrl: GraphQLTypes["UploadPreSignedUrl"],
	confirmUpload: boolean,
	['...on Mutation']: Omit<GraphQLTypes["Mutation"], "...on Mutation">
};
	["RegisterUserInput"]: {
		email: string,
	roleId: string
};
	["CreateUserInput"]: {
		email: string,
	password: string,
	firstName: string,
	lastName: string,
	roleId: string
};
	["UpdateUserInput"]: {
		email?: string | undefined | null,
	firstName?: string | undefined | null,
	lastName?: string | undefined | null,
	roleId?: string | undefined | null,
	id: string
};
	["UpsertScormTrackingInput"]: {
		completionStatus?: GraphQLTypes["ScormCompletionStatus"] | undefined | null,
	successStatus?: GraphQLTypes["ScormSuccessStatus"] | undefined | null,
	scoreRaw?: number | undefined | null,
	scoreMin?: number | undefined | null,
	scoreMax?: number | undefined | null,
	scoreScaled?: number | undefined | null,
	totalTime?: string | undefined | null,
	sessionTime?: string | undefined | null,
	suspendData?: string | undefined | null,
	location?: string | undefined | null
};
	["Subscription"]: {
	__typename: "Subscription",
	basicSubscription?: string | undefined | null,
	['...on Subscription']: Omit<GraphQLTypes["Subscription"], "...on Subscription">
};
	["ID"]: "scalar" & { name: "ID" }
    }
export enum AccountStatus {
	PENDING_ACTIVATION = "PENDING_ACTIVATION",
	ENABLED = "ENABLED",
	DISABLED = "DISABLED"
}
export enum RoleEnum {
	Admin = "Admin",
	Formateur = "Formateur",
	User = "User",
	Guest = "Guest"
}
export enum ScormCompletionStatus {
	COMPLETED = "COMPLETED",
	INCOMPLETE = "INCOMPLETE",
	NOT_ATTEMPTED = "NOT_ATTEMPTED",
	UNKNOWN = "UNKNOWN"
}
export enum ScormSuccessStatus {
	PASSED = "PASSED",
	FAILED = "FAILED",
	UNKNOWN = "UNKNOWN"
}
export enum EError {
	AUTH = "AUTH"
}
export enum OrderByEnum {
	ASC = "ASC",
	DESC = "DESC"
}

type ZEUS_VARIABLES = {
	["DateTime"]: ValueTypes["DateTime"];
	["AccountStatus"]: ValueTypes["AccountStatus"];
	["RoleEnum"]: ValueTypes["RoleEnum"];
	["ScormCompletionStatus"]: ValueTypes["ScormCompletionStatus"];
	["ScormSuccessStatus"]: ValueTypes["ScormSuccessStatus"];
	["EError"]: ValueTypes["EError"];
	["FindManyUserWithFiltersInput"]: ValueTypes["FindManyUserWithFiltersInput"];
	["UserOrderByInput"]: ValueTypes["UserOrderByInput"];
	["OrderByEnum"]: ValueTypes["OrderByEnum"];
	["UserFilterByInput"]: ValueTypes["UserFilterByInput"];
	["FindManyScormTrackingWithFiltersInput"]: ValueTypes["FindManyScormTrackingWithFiltersInput"];
	["ScormTrackingOrderByInput"]: ValueTypes["ScormTrackingOrderByInput"];
	["ScormTrackingFilterByInput"]: ValueTypes["ScormTrackingFilterByInput"];
	["RegisterUserInput"]: ValueTypes["RegisterUserInput"];
	["CreateUserInput"]: ValueTypes["CreateUserInput"];
	["UpdateUserInput"]: ValueTypes["UpdateUserInput"];
	["UpsertScormTrackingInput"]: ValueTypes["UpsertScormTrackingInput"];
	["ID"]: ValueTypes["ID"];
}